"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Time = _interopRequireDefault(require("../Time/Time"));

var _TimePickerItem = _interopRequireDefault(require("./_TimePickerItem"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/** A **TimePicker** allows the user to easily set a time using the **Time** component. */
var TimePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimePicker, _Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimePicker);
    _this = _super.call(this, props);

    _this.onChange = function (time) {
      _this.setState(function () {
        var value = time ? _this.formatValue(time) : '';

        _this.props.onChange({
          time: time,
          formattedTime: value
        });

        return {
          time: time,
          value: value
        };
      });
    };

    _this.updateValue = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.formatWithLeadingZero = function (value) {
      return (0, _parseInt2.default)(value, 10) < 10 ? '0' + (0, _parseInt2.default)(value, 10) : value;
    };

    _this.formatValue = function (time) {
      var value = '';

      if (_this.state.showHour) {
        value = _this.formatWithLeadingZero(time.hour);
      }

      if (_this.state.showMinute) {
        value = value ? value + ':' + _this.formatWithLeadingZero(time.minute) : _this.formatWithLeadingZero(time.minute);
      }

      if (_this.state.showSecond) {
        value = value ? value + ':' + _this.formatWithLeadingZero(time.second) : _this.formatWithLeadingZero(time.second);
      }

      if (_this.state.format12Hours) {
        value = value + ' ' + _this.CLOCK[time.meridiem];
      }

      return value;
    };

    _this.getFormattedTime = function (value) {
      var time = {};
      var timeArray = [];

      if ((0, _includes.default)(value).call(value, _this.props.localizedText.meridiemAM) || (0, _includes.default)(value).call(value, _this.props.localizedText.meridiemPM)) {
        var _context;

        var splitBySpace = (0, _slice.default)(_context = (0, _trim.default)(value).call(value).match(/^(\S+)\s(.*)/)).call(_context, 1);
        var timeMerideim = splitBySpace[1];
        timeArray = splitBySpace[0].split(':');
        timeArray.push(timeMerideim);
      } else {
        timeArray = (0, _trim.default)(value).call(value).split(':');
      }

      if (typeof timeArray[0] !== 'undefined' && _this.props.showHour) {
        time.hour = _this.formatWithLeadingZero(timeArray[0]);
      }

      if (typeof timeArray[1] !== 'undefined' && _this.props.showMinute) {
        time.minute = _this.formatWithLeadingZero(timeArray[1]);
      }

      if (typeof timeArray[2] !== 'undefined' && _this.props.showSecond) {
        if (timeArray[2] !== _this.props.localizedText.meridiemPM && timeArray[2] !== _this.props.localizedText.meridiemAM) {
          time.second = _this.formatWithLeadingZero(timeArray[2].match(/\d+/)[0]);
        }

        if (_this.props.format12Hours) {
          var _context2;

          time.meridiem = (0, _indexOf.default)(_context2 = timeArray[timeArray.length - 1]).call(_context2, _this.props.localizedText.meridiemAM) !== -1 ? 0 : 1;
        }
      } else {
        if (_this.props.format12Hours) {
          var _context3;

          time.meridiem = (0, _indexOf.default)(_context3 = timeArray[timeArray.length - 1]).call(_context3, _this.props.localizedText.meridiemAM) !== -1 ? 0 : 1;
        }
      }

      return time;
    };

    _this.CLOCK = [_this.props.localizedText.meridiemAM, _this.props.localizedText.meridiemPM];
    var _time = _this.props.time;
    var _value = '';
    var defaultTime = typeof props.value !== 'undefined' ? _this.getFormattedTime(props.value) : {};
    _this.state = {
      time: {
        hour: typeof defaultTime.hour !== 'undefined' ? defaultTime.hour : _time.hour,
        minute: typeof defaultTime.minute !== 'undefined' ? defaultTime.minute : _time.minute,
        second: typeof defaultTime.second !== 'undefined' ? defaultTime.second : _time.second,
        meridiem: typeof defaultTime.meridiem !== 'undefined' ? defaultTime.meridiem : _time.meridiem
      },
      showHour: props.showHour,
      showMinute: props.showMinute,
      showSecond: props.showSecond,
      format12Hours: props.format12Hours,
      value: typeof props.value !== 'undefined' ? props.value : '',
      disabled: props.disabled,
      placeholder: '',
      popoverId: props.id ? props.id + '-popover' : '',
      timeId: props.id ? props.id + '-time' : ''
    };

    if (_this.state.showHour) {
      _value = 'hh';
    }

    if (_this.state.showMinute) {
      _value = _value ? _value + ':mm' : 'mm';
    }

    if (_this.state.showSecond) {
      _value = _value ? _value + ':ss' : 'ss';
    }

    if (_this.state.format12Hours) {
      _value = _value + ' am/pm';
    }

    _this.state.placeholder = _value;
    return _this;
  }

  (0, _createClass2.default)(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          popoverProps = _this$props.popoverProps,
          id = _this$props.id,
          inputProps = _this$props.inputProps,
          localizedText = _this$props.localizedText,
          buttonProps = _this$props.buttonProps,
          disabled = _this$props.disabled,
          format12Hours = _this$props.format12Hours,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          time = _this$props.time,
          value = _this$props.value,
          timeProps = _this$props.timeProps,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["popoverProps", "id", "inputProps", "localizedText", "buttonProps", "disabled", "format12Hours", "showHour", "showMinute", "showSecond", "time", "value", "timeProps"]);
      var _this$state = this.state,
          popoverId = _this$state.popoverId,
          timeId = _this$state.timeId;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        id: id
      }), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
        body: /*#__PURE__*/_react.default.createElement(_Time.default, (0, _extends2.default)({}, timeProps, {
          disabled: this.state.disabled,
          format12Hours: this.state.format12Hours,
          id: timeId,
          onChange: this.onChange,
          onUpdateTime: this.updateTime,
          showHour: this.state.showHour,
          showMinute: this.state.showMinute,
          showSecond: this.state.showSecond,
          time: this.state.time
        })),
        control: /*#__PURE__*/_react.default.createElement(_TimePickerItem.default, (0, _extends2.default)({}, props, {
          buttonProps: buttonProps,
          disabled: this.state.disabled,
          format12Hours: format12Hours,
          id: id,
          inputProps: inputProps,
          localizedText: localizedText,
          onChange: this.onChange,
          placeholder: this.state.placeholder,
          showHour: showHour,
          showMinute: showMinute,
          showSecond: showSecond,
          time: this.state.time,
          updateTime: this.updateTime,
          updateValue: this.updateValue,
          value: this.state.value
        })),
        id: popoverId,
        noArrow: true
      })));
    }
  }]);
  return TimePicker;
}(_react.Component);

TimePicker.displayName = 'TimePicker';
process.env.NODE_ENV !== "production" ? TimePicker.propTypes = _objectSpread(_objectSpread({}, _Time.default.basePropTypes), {}, {
  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    meridiemAM: _propTypes.default.string,
    meridiemPM: _propTypes.default.string
  }),

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Additional props to be spread to the `Time` component */
  timeProps: _propTypes.default.object,

  /** Initial time value for the input. Accepted time format : hh:mm:ss am/pm, Eg: 10:32:30 am */
  value: _propTypes.default.string,

  /** Callback function when the change event fires on the component */

  /**
   * Callback function; triggered when the current time is changed by picking from popover or editing the `<input>` field.
   * Fired only when formatted string is valid.
   *
   * @param {Object} data - has formattedTime string and time.hour, time.meridiem, time.minute, and time.second as numbers
   * @returns {void}
   * */
  onChange: _propTypes.default.func
}) : void 0;
TimePicker.defaultProps = {
  localizedText: {
    meridiemAM: 'am',
    meridiemPM: 'pm'
  },
  showHour: true,
  showMinute: true,
  showSecond: true,
  time: {
    hour: '00',
    minute: '00',
    second: '00',
    meridiem: 0
  },
  onChange: function onChange() {}
};

var _default = (0, _withStyles.default)(TimePicker);

exports.default = _default;